<template>
  <section class="mb-20">
    <div class="card border-psychology-primary/20 bg-psychology-primary/5">
      <div class="p-8 text-center">
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="w-16 h-16 text-psychology-primary mx-auto mb-6">
          <path d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z"></path>
        </svg>
        <h2 class="text-2xl font-bold text-psychology-primary mb-4">
          您的隐私是我们的首要关注
        </h2>
        <p class="text-lg text-gray-600 mb-6 max-w-3xl mx-auto">
          所有评估数据仅在您的设备本地处理和存储，不会上传到任何服务器。
          您拥有完全的数据控制权，可以随时删除或导出您的评估历史。
        </p>
        <div class="grid md:grid-cols-3 gap-6 max-w-2xl mx-auto">
          <div class="flex items-center gap-2 justify-center">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="w-5 h-5 text-psychology-success">
              <path d="M21.801 10A10 10 0 1 1 17 3.335"></path>
              <path d="m9 11 3 3L22 4"></path>
            </svg>
            <span class="text-sm font-medium">本地数据存储</span>
          </div>
          <div class="flex items-center gap-2 justify-center">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="w-5 h-5 text-psychology-success">
              <path d="M21.801 10A10 10 0 1 1 17 3.335"></path>
              <path d="m9 11 3 3L22 4"></path>
            </svg>
            <span class="text-sm font-medium">完全匿名化</span>
          </div>
          <div class="flex items-center gap-2 justify-center">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="w-5 h-5 text-psychology-success">
              <path d="M21.801 10A10 10 0 1 1 17 3.335"></path>
              <path d="m9 11 3 3L22 4"></path>
            </svg>
            <span class="text-sm font-medium">可随时删除</span>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'PrivacySection'
}
</script>

